
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.md?watch=parent';
    export const demoIndex = {
  ids: ["organizationchart-demo-common","organizationchart-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__OrganizationChart" */'/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.md?type=demo')
};